module.exports = __webpack_public_path__ + "img/miner3.c6e678e3.png";